export * from './src/events-v2-rsvp-rsvp-v-2.meta.js';
